<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  // width: calc(100% - 40px);
  min-width: 500px;

  // 表格
  .table {
    width: calc(100% - 0px);
    margin-top: 24px;

    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding: 5px;
      color: #909399;

      .item {
        width: 50%;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          width: 60%;
        }
      }
    }
  }
}
</style>
<template>
  <div class="container">
    <div class="form" style="margin-bottom: 20px;">
      <el-form style="height:28px;" :model="deviceAlarm.searchForm" :inline="true" size="mini">
        <el-form-item :label="$t('tongjishijian')">
          <yi_time_input :format="'yyyy-MM-dd'" :maxTime="31 * 24 * 3600 * 1000" type="daterange" :start.sync="deviceAlarm.searchForm.startTimeStart" :end.sync="deviceAlarm.searchForm.startTimeEnd"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="deviceAlarm.searchForm.equipmentId"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('chixushijian (fenzhong) dayu')">
          <el-input v-model="deviceAlarm.searchForm.duration"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDeviceAlarm" plain>{{ $t('sousuo') }} </el-button>
          <el-button type="default" @click="resetDeviceAlarm" plain style="margin-left: 10px;">
            {{ $t('chongzhi') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="float: right; margin-top: 8px; margin-bottom: 8px;">
      <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportAlarm()"> </el-button>
    </div>
    <!-- 表单 -->
    <div class="table">
      <el-table :data="deviceAlarm.tableData" size="mini" border style="width: 100%" v-loading="searchLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
        <el-table-column v-for="(item, index) in deviceAlarm.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ item.isTranslated ? $t(scope.row[item.prop]) : scope.row[item.prop] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('guzhangleixing')" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.alarmType === 1 ? 'warning' : 'danger'">
              {{ $t(store.state.dictJsonAll['EQUIPMENT_ALARM_TYPE'][scope.row.alarmType]) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="float: right; margin-top:8px">
        <el-pagination class="fy" layout="total, prev, pager, next,sizes" :current-page="deviceAlarm.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :total="parseInt(deviceAlarm.total)" :pagerCount="5" background> </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
const date = new Date();
const startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime();
export default {
  name: 'web_report_equipment_alarm_list',
  data() {
    return {
      searchLoading: false,
      exportLoading: false,
      fildIds: '',
      timer: null,
      // refreshOneKey: 0,
      deviceAlarm: {
        searchForm: {
          equipmentId: [],
          startTimeStart: startTime,
          startTimeEnd: endTime,
          summaryDate: [],
          duration: 0
        },
        tableData: [],
        tableColumn: [
          {
            prop: 'equipmentName',
            sortable: false,
            label: 'shebeimingcheng'
          },
          {
            prop: 'alarmMsg',
            label: 'baojingxinxi',
            isTranslated: true
          },
          {
            prop: 'startTime',
            sortable: false,
            label: 'kaishishijian'
          },
          {
            prop: 'endTime',
            sortable: false,
            label: 'jieshushijian'
          },
          {
            prop: 'duration',
            sortable: false,
            label: 'chixushijian (fenzhong)'
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    };
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    //导出
    exportAlarm() {
      this.exportLoading = true;
      let requestParam = {
        ...this.deviceAlarm.searchForm,
        equipmentId:this.deviceAlarm.searchForm.equipmentId.join(','),
        endTimeStart:this.deviceAlarm.searchForm.startTimeStart,
        endTimeEnd:this.deviceAlarm.searchForm.startTimeEnd,
        duration:this.deviceAlarm.searchForm.duration*60,
        orderBy: 'startTime'
      };
      return this.http
        .get('/web/report/export/equipment_alarm_export?' + this.qs.stringify(requestParam))
        .then(response => {
          let fildId = response.data;
          return this.http
            .get('/web/report/work/get', {
              params: {
                id: fildId
              }
            })
            .then(response => {
              this.fildIds = response.data.fileId;
              console.log('response.msg1', response.data.status);
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            })
            .finally(() => {
              this.exportLoading = false;
            });
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    resetDeviceAlarm() {
      orderBy: 'startTime asc';
      this.deviceAlarm.searchForm = {
        equipmentId: null,
        summaryDate: '',
        duration: 0
      };
      this.deviceAlarm.tableData = undefined;
    },
    handleSizeChange(value) {
      this.deviceAlarm.pageSize = value;
      this.getDeviceAlarm();
    },
    handleCurrentChange(value) {
      this.deviceAlarm.currentPage = value;
      this.getDeviceAlarm();
    },
    changeDeviceAlarm(value) {
      if (value === null) {
        return false;
      }
      const start = new Date(value[0]).getTime();
      const end = new Date(value[1]).getTime();
      const diff = end - start;
      const max = 3600 * 24 * 1000 * 30;
      console.log('fffff', max);
      if (diff > max) {
        this.$message.error(this.$t('shijiankuadubunengchaoguo31tian'));
        this.deviceAlarm.searchForm.summaryDate = [];
      }
    },
    async getDeviceAlarm() {
      this.searchLoading = true;
      let pageParam = {
        ...this.deviceAlarm.searchForm,
        equipmentId:this.deviceAlarm.searchForm.equipmentId.join(','),
        endTimeStart:this.deviceAlarm.searchForm.startTimeStart,
        endTimeEnd:this.deviceAlarm.searchForm.startTimeEnd,
        duration:this.deviceAlarm.searchForm.duration*60,
        pageSize: this.deviceAlarm.pageSize,
        pageNum: this.deviceAlarm.currentPage,
        orderBy: 'startTime asc'
      };
      let response = await this.http
        .get('/web/report/page/equipment_alarm?' + this.qs.stringify(pageParam))
        .then(response => {
          this.deviceAlarm.tableData = response.data.rows;
          this.deviceAlarm.total = response.data.total;
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.searchLoading = false;
        });

      if (this.deviceAlarm.tableData.length > 0) {
        for (let i = 0; i < this.deviceAlarm.tableData.length; i++) {
          this.deviceAlarm.tableData[i]['duration'] = (this.deviceAlarm.tableData[i]['duration'] / 60).toFixed(1);
          this.deviceAlarm.tableData[i]['startTime'] = this.dateFormat(this.deviceAlarm.tableData[i]['startTime']);
          this.deviceAlarm.tableData[i]['endTime'] = this.dateFormat(this.deviceAlarm.tableData[i]['endTime']);
        }
      }
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    }
  }
};
</script>
